import { createRequestTypes } from 'common/websocket-redux';

export const GET_USER_VACCINATION_WORKFLOW = createRequestTypes(
  'employer-experience/user-vaccination-workflow/GET_USER_VACCINATION_WORKFLOW',
);

export const getUserVaccinationWorkflow = ({ vaccineType, userId }) =>
  GET_USER_VACCINATION_WORKFLOW.request({ vaccineType, userId });
